import React, { useContext, JSX } from 'react';
import * as Styled from './style';
import { Grid, Divider, Typography } from '@mui/material';
import { ThemeContext } from '../../context/ThemeContext';
import useCustomMediaQuery from 'utils/useCustomMediaQuery';
import { screenSizes } from 'constants/Constants';

interface KpiMetric {
  data: string | number;
  text: string;
}

interface Props {
  kpiMetricsData: KpiMetric[];
  isIncidentMonitoringOverview?: boolean;
}

export default function KPIMetricsForTwo({
  kpiMetricsData,
  isIncidentMonitoringOverview = false,
}: Props): JSX.Element {
  const isMobile = useCustomMediaQuery(screenSizes.mobile);
  const isTablet = useCustomMediaQuery(screenSizes.tablet);
  const ipadMini = useCustomMediaQuery(screenSizes.ipadMini);
  const ipadPro = useCustomMediaQuery(screenSizes.ipadPro);
  const ipadAir = useCustomMediaQuery(screenSizes.ipadAir);
  const getWidthOfMetrics = () => {
    if (
      isIncidentMonitoringOverview &&
      !isMobile &&
      !isTablet &&
      !ipadMini &&
      !ipadPro &&
      !ipadAir
    ) {
      return 3.9;
    } else if (isIncidentMonitoringOverview && (isMobile || ipadPro)) {
      return 6;
    } else if (
      (isIncidentMonitoringOverview && isTablet) ||
      ipadMini ||
      ipadAir
    ) {
      return 3.8;
    }
    return 6;
  };
  const metricsItems: JSX.Element[] | undefined = kpiMetricsData?.map(
    (metricItem: KpiMetric, index: number) => {
      return (
        <Grid
          item
          container
          key={index}
          xs={getWidthOfMetrics()}
          className="metricsBlock"
        >
          <Grid item height={'100%'}>
            {index === 0 ? null : (
              <Divider
                orientation="vertical"
                flexItem
                className="metricsDivider"
                variant="middle"
              />
            )}
          </Grid>
          <Grid item container xs={11.9} className="metricsItem">
            <Grid item xs={12} className="metricsData">
              {metricItem?.data}
            </Grid>
            <Grid item xs={12}>
              <Typography className="metricsText">
                {metricItem?.text}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      );
    }
  );
  const { mode } = useContext(ThemeContext);
  return (
    <Styled.KPIMetricsForTwoContainer
      data-testid="kpi-metrics-for-two-container"
      themeMode={mode}
    >
      <Grid container className="scorecardContainer">
        {metricsItems}
      </Grid>
    </Styled.KPIMetricsForTwoContainer>
  );
}
